import { injectCpmsBoLocationApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-location.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoLocationApi = injectCpmsBoLocationApi(baseApi);

export const {
  useCpmsBoGetLocationsPaginatedQuery,
  useCpmsBoGetLocationQuery,
  useCpmsBoCreateLocationMutation,
  useCpmsBoUpdateLocationMutation,
  useCpmsBoDeleteLocationMutation,
} = cpmsBoLocationApi;
